import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  opacity: 0.8;\n  color: ", ";\n  opacity: 0.8;\n  position: absolute;\n  right: 0;\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", " ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 0px;\n  margin: 0px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n\n  textarea {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 16px;\n  display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", " padding-left: 40px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { darkInputBase, darkInputHeight } from '../../styles/formsDark';
import { inputBase, inputHeight, inputError, inputWithIcon, errorBackgroundImage, validBackgroundImage } from '../../styles/formsLight';
import { jumbo, mystic } from '../../styles/colors';
var NUMBER = 'number';
var SEARCH = 'search';
var numberTypeStyle = "\n  width: 100%;\n  padding-right: 0;\n";
var numberTypeErrorStyle = "\n  background-position: calc(100% - 1.5rem), 0;\n";

function searchTypeStyle(height) {
  return "\n    border-radius: ".concat(height, ";\n    box-sizing: inherit;\n  ");
}

function getInputTheme(theme, type) {
  if (theme === 'dark') {
    return "\n      ".concat(darkInputBase, "\n      ").concat(type === NUMBER ? numberTypeStyle : '', "\n      ").concat(type === SEARCH ? searchTypeStyle(darkInputHeight) : '', "\n    ");
  }

  if (theme === 'light') {
    return "\n      ".concat(inputBase, "\n      ").concat(type === NUMBER ? numberTypeStyle : '', "\n      ").concat(type === SEARCH ? searchTypeStyle(inputHeight) : '', "\n      background-color: white;\n      border-color: ").concat(mystic, ";\n      :hover {\n        background-color: white;\n      }\n    ");
  }

  return "\n    ".concat(inputBase, "\n    ").concat(type === NUMBER ? numberTypeStyle : '', "\n    ").concat(type === SEARCH ? searchTypeStyle(inputHeight) : '', "\n  ");
}

export var InputIconContainer = styled.div(_templateObject());
export var InputWithIcon = styled.input(_templateObject2(), function (_ref) {
  var theme = _ref.theme,
      type = _ref.type;
  return getInputTheme(theme, type);
});
export var Icon = styled.div(_templateObject3());
export var InputStyled = styled.input(_templateObject4(), function (_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type;
  return getInputTheme(theme, type);
});
export var TextareaStyled = styled.div(_templateObject5(), function (_ref3) {
  var theme = _ref3.theme;

  if (theme === 'dark') {
    return "\n          ".concat(darkInputBase, "\n          line-height: 1.3em;\n          resize: none;\n          padding-top: 0.75rem;\n          padding-bottom: 0.75rem;\n        ");
  }

  return "\n        ".concat(inputBase, "\n        line-height: 1.3em;\n        resize: none;\n        padding-top: 0.75rem;\n        padding-bottom: 0.75rem;\n      ");
});
export var InputContainer = styled.div(_templateObject6());
export var Main = styled.span(_templateObject7(), function (_ref4) {
  var error = _ref4.error,
      inputType = _ref4.inputType;
  return error && "\n    input, textarea {\n      ".concat(inputError, "\n    }\n\n    input {\n      ").concat(inputWithIcon, "\n      ").concat(errorBackgroundImage, "\n\n      ").concat(inputType === NUMBER ? numberTypeErrorStyle : '', "\n      ").concat(inputType === SEARCH ? searchTypeStyle(inputHeight) : '', "\n    }\n  ");
}, function (_ref5) {
  var valid = _ref5.valid;
  return valid && "\n    input {\n      ".concat(inputWithIcon, "\n      ").concat(validBackgroundImage, "\n    }\n  ");
});
export var Help = styled.div(_templateObject8(), jumbo, function (_ref6) {
  var label = _ref6.label;
  return label ? 'top: 4px;' : 'top: -50%';
});